import React from 'react';

class VideoTitle extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }
  handleMouseEnterOrMouseMove = (e) => {
    //e.preventDefault(); // controlsが表示されなくなるのでcancelしない
    this.props.onOverlayFixed(true);
  };
  handleMouseLeave = (e) => {
    //e.preventDefault(); // controlsが表示されなくなるのでcancelしない
    this.props.onOverlayFixed(false);
  };
  shouldComponentUpdate = (nextProps, nextState) => {
    return nextProps.program !== this.props.program || nextProps.overlay !== this.props.overlay;
  }
  render = () => {
    const overlay = this.props.overlay;
    if (!overlay || this.props.isFullscreen) {
      return (<div/>);
    }
    const service = this.props.service;
    const program = this.props.program;
    var programName = '';
    if (program) programName = program.name;
    return (
      <div
        id="video-title"
        style={{position: 'absolute', left: '0px', top: '0px', padding:'4px', width: '100%'}}
        onMouseEnter={this.handleMouseEnterOrMouseMove}
        onMouseMove={this.handleMouseEnterOrMouseMove}
      >
        <div
          className="overlay-text"
          >
          <div>{service.name}&nbsp;&nbsp;{programName}</div>
        </div>
      </div>
    );
  };
}

export default VideoTitle;



// WEBPACK FOOTER //
// ./src/components/VideoTitle.js